module.exports = __webpack_public_path__ + "img/designguide.e0ef62e.webp";